var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner"},[_c('b-spinner',{attrs:{"variant":"secondary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }